module.exports = __webpack_public_path__ + "static/img/female-bg-pt.9c6fe3fd.png";